import { locationTypes, parseLocationKey } from '../../locations/index.js';
class LocationKey {
    constructor( key ) {
        if ( !LocationKey.isValid( key ) ) {
            throw new Error( 'invalid location key string' );
        }

        const { id, type } = parseLocationKey( key );
        this.id = id;
        this.type = type;
    }

    toString() {
        return `${this.type}:${this.id}`;
    }

    static isValid( key ) {
        const tokens = key.split( ':' );

        if ( tokens.length !== 2 ) {
            return false;
        }

        const type = tokens[ 0 ];

        const validLocationTypes = [ ...locationTypes, 'town' ];

        if ( !validLocationTypes.includes( type ) ) {
            return false;
        }

        const id = parseInt( tokens[ 1 ] );

        if ( !id || id === 0 ) {
            return false;
        }

        return true;
    }
}

export default LocationKey;
